import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
  Container,
  Paper
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

export default function AuthPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // Login form state
  const [loginForm, setLoginForm] = useState({
    email: '',
    password: ''
  });

  const { login } = useAuth();

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(loginForm.email, loginForm.password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  const handleLoginChange = (field) => (e) => {
    setLoginForm(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '100vh',
          justifyContent: 'center',
          py: 4
        }}
      >
        <Paper elevation={3} sx={{ width: '100%', maxWidth: 400 }}>
          <Typography
            component="h1"
            variant="h4"
            align="center"
            sx={{ pt: 3, pb: 2 }}
          >
            Tracking Dashboard
          </Typography>
          
          <Typography
            variant="body2"
            align="center"
            color="text.secondary"
            sx={{ pb: 3 }}
          >
            Please sign in to continue
          </Typography>

          {error && (
            <Alert severity="error" sx={{ m: 2 }}>
              {error}
            </Alert>
          )}

          {/* Login Form */}
          <Box sx={{ p: 3 }}>
            <form onSubmit={handleLoginSubmit}>
              <TextField
                required
                fullWidth
                label="Email Address"
                type="email"
                value={loginForm.email}
                onChange={handleLoginChange('email')}
                margin="normal"
                disabled={loading}
              />
              <TextField
                required
                fullWidth
                label="Password"
                type="password"
                value={loginForm.password}
                onChange={handleLoginChange('password')}
                margin="normal"
                disabled={loading}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={loading}
                sx={{ mt: 3, mb: 2 }}
              >
                {loading ? <CircularProgress size={24} /> : 'Sign In'}
              </Button>
            </form>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}